"use strict";

const features = new Swiper( '.features .swiper', {
	breakpoints: {
		1024: {
			slidesPerView: 3
		}
	},
	pagination: {
		el: '.swiper-pagination'
	},
	slidesPerView: 1,
	spaceBetween: 20
} );

const testimonials = new Swiper( '.testimonials .swiper', {
	breakpoints: {
		1024: {
			slidesPerView: 2
		},
		1440: {
			slidesPerView: 3
		}
	},
	navigation: {
		nextEl: '.testimonials__inner .swiper-button-next',
		prevEl: '.testimonials__inner .swiper-button-prev',
	},
	pagination: {
		el: '.swiper-pagination'
	},
	slidesPerView: 1,
	spaceBetween: 20,
  	initialSlide: 1
} );

addEventListener( "resize", ( event ) => {
	features.update();
	testimonials.update();
} );



